import { Outlet } from "react-router-dom";

export const InventorySparesOutlet = () => {
  return <Outlet />;
};
